import { numberToPrettyString } from '@cian/utils';

export function toFixedPrettyDecimal(decimal: number): string {
  const fixedDecimal = Number(decimal.toFixed(2));

  return numberToPrettyString(fixedDecimal);
}
